import React, { useState, useEffect } from "react";
import firebase from "./firebaseConfig"; // Adjust the path to your firebaseConfig file
import StepOne from "./StepOne";
import StepTwo from "./StepTwo";
import PreviewStep from "./PreviewStep";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./App.css";
import Loader from "./Loader";
import "./Loader.css";
import axios from "axios";
import createOrder from "./CreateOrder";

const StepForm = ({countryName}) => {
  const selectedCountryValue = countryName;
  const [formattedData, setFormattedData] = useState("");
  const [utmDetails, setUtmDetails] = useState(null);
  const [step, setStep] = useState(0);
  const [formResponseId, setFormResponseId] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [userData, setUserData] = useState({
    username: "",
    useremail: "",
    mobile: "",
  });
  const [otp, setOtp] = useState("");
  const countryCodeMap = {
    "/us": "+1",
    "/uk": "+44",
    "/th": "+66",
    "/in": "+91",
    "/au": "+61",
    "/ph": "+63",
  };
  const matchedCountryCode =
  Object.entries(countryCodeMap).find(([path]) =>
    window.location.href.includes(path)
  )?.[1] || "+91";

  const defaultisd = window.location.href.includes("/us")
    ? "+1"
    : window.location.href.includes("/uk")
    ? "+44"
    : "+91";
  const [isd, setIsd] = useState(matchedCountryCode);
  const appCode = "HMPL";
  const queryString = window.location.search; // Get the query string from the URL
  const urlParams = new URLSearchParams(queryString);
  const { slug } = useParams();
  const location = useLocation();
  const urlQuery = location.search;

  const navigate = useNavigate();

  const mmhApiUrl = `${process.env.REACT_APP_API_URL_MMH}`;
  // const mmhApiUrl = "https://api-uat.makemyhouse.com";

  const handleCountryCodeChange = (code) => {
    setIsd(code);
    console.log("selected country code", code);
  };
  const handleNext2 = () => {
    setStep(step + 1);
  };
  useEffect(() => {
    console.log("step", step);
  }, [step]);
  const handleNext = async () => {
    if (step === 1) {
      setIsLoading(true);
      // Initialize reCAPTCHA verifier
      // const verifier = new firebase.auth.RecaptchaVerifier(
      //   "recaptcha-container",
      //   {
      //     size: "invisible",
      //     callback: (response) => {
      //       // reCAPTCHA resolved, continue with sending OTP
      //     },
      //     "error-callback": (error) => {
      //       // Handle the error here
      //       console.error("Error initializing reCAPTCHA verifier:", error);
      //       return;
      //     },
      //   }
      // );

      // Call Send Otp Api Required Fields: isd,mobile,appcode
      const sendOtpUrl = `${mmhApiUrl}/customer/me/loginotp`;
      console.log("email: ", userData?.useremail);
      console.log("name: ", userData?.username);
      try {
        let formData2 = new FormData();
        formData2.append("mobile", userData.mobile);
        formData2.append("isd", isd.replace("+", ""));
        formData2.append("appcode", appCode);
        formData2.append("name", userData?.username);
        formData2.append("email", userData?.useremail);
        formData2.append("utm_source", utmDetails?.utm_source);
        formData2.append("utm_medium", utmDetails?.utm_medium);
        formData2.append("utm_campaign", utmDetails?.utm_campaign);

        const response = await axios.post(sendOtpUrl, formData2);

        console.log("SendOtpResponse: ", response);

        if (response.status === 200) {
          // API For CRM Entry (same as verify OTP step)
          try {
            const isUS2 = window.location.href.includes("/us");
            const isUK2 = window.location.href.includes("/uk");
            const finalUrl2 = isUS2
              ? `/us/response/checkout/${slug}${urlQuery}&isd=${isd}&mobile=${userData?.mobile}`
              : isUK2
              ? `/uk/response/checkout/${slug}${urlQuery}&isd=${isd}&mobile=${userData?.mobile}`
              : `/response/checkout/${slug}${urlQuery}&isd=${isd}&mobile=${userData?.mobile}`;
            const name = userData.username ? userData.username : userData.mobile;
            const updateApiUrl = `${process.env.REACT_APP_API_URL}updateResponse/${formResponseId}`;

            await axios.post(
              updateApiUrl,
              {
                mobileNumber: userData.mobile,
                name: name,
                isd: isd,
                btnUrl: finalUrl2,
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer vcju67w54b vuttf67t63byua213bk`,
                },
              }
            );
          } catch (updateError) {
            // Do not block OTP flow if CRM update fails
            console.error("updateResponse failed on send OTP:", updateError);
          }
          setStep(step + 1);
          setIsLoading(false);
        } else if (response.status === 403) {
          setIsLoading(false);
          alert(
            response.data.msg ||
              "Access forbidden: You do not have permission to access this resource."
          );
        } else {
          setIsLoading(false);
          alert("Something Went Wrong!");
          return;
        }
      } catch (error) {
        setIsLoading(false);
        if (error.response) {
          // Server responded with a status code out of the range of 2xx
          if (error.response.status === 403) {
            alert(
              error.response.data.msg ||
                "Access forbidden: You do not have permission to access this resource."
            );
          } else {
            alert(`HTTP error! Status: ${error.response.status}`);
          }
        } else if (error.request) {
          // Request was made but no response received
          alert("No response received from the server.");
        } else {
          // Something else happened while setting up the request
          alert("Error: " + error.message);
        }
      }
    } else {
    }
    if (step === 2) {
      setStep(step - 1);
    }
  };

  const isProjectAvailable = async (formResponseId) => {
    try {
      const url = `https://api.makemyhouse.com/homeplanner/projects/match/${formResponseId}`;
      const response = await axios.get(url);

      if (response.status === 200) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error("Error checking project availability:", error);
      return false;
    }
  };

  const handleVerifyOtp = async () => {
    setIsLoading(true);
    // Call Verify OTP Api Required Fields : otp, mobile, appcode, isd
    const verifyOtpUrl = `${mmhApiUrl}/customer/me/veryfyotp`;

    // Create a new FormData object
    let formData = new FormData();
    formData.append("mobile", userData.mobile);
    formData.append("isd", isd.replace("+", ""));
    formData.append("appcode", appCode);
    formData.append("otp", otp);

    formData.append("name", userData?.username);
    formData.append("email", userData?.useremail);
    formData.append("duplicate", 1);
    formData.append("leadsource", "Floor Planner");
    formData.append("leadstatus", "Hot");
    formData.append("typestatus", "not contacted");
    formData.append("response_form_id", formResponseId);
    formData.append("requirement", formattedData);
    formData.append("utm_source", utmDetails?.utm_source);
    formData.append("utm_medium", utmDetails?.utm_medium);
    formData.append("utm_campaign", utmDetails?.utm_campaign);

    try {
      const response2 = await axios.post(verifyOtpUrl, formData);

      if (response2.status === 200) {
        // For btnUrl Only No Use in app
        localStorage.setItem("authToken", response2.data.token);
        const token = response2.data.token;
        const isUS2 = window.location.href.includes("/us");
        const isUK2 = window.location.href.includes("/uk");
        const finalUrl2 = isUS2
          ? `/us/response/checkout/${slug}${urlQuery}&isd=${isd}&mobile=${userData?.mobile}`
          : isUK2
          ? `/uk/response/checkout/${slug}${urlQuery}&isd=${isd}&mobile=${userData?.mobile}`
          : `/response/checkout/${slug}${urlQuery}&isd=${isd}&mobile=${userData?.mobile}`;
        // End

        // API For CRM Entry
        var name = userData.username ? userData.username : userData.mobile;

        const apiUrl = `${process.env.REACT_APP_API_URL}updateResponse/${formResponseId}`;
        //  For Free package Only
        var dataForFreeProduct = {
          responseFormId: formResponseId,
          isd: isd.replace("+", "") || "91",
          mobile: userData.mobile,
          offerType: "free",
          brandCode: "hpn",
          productid: 106,
          lang: "en",
        };

        const isUS = window.location.href.includes("/us");
        const isUK = window.location.href.includes("/uk");
        const finalUrl = isUS
          ? `/us/thank-you?moid=${formResponseId}&flag=free`
          : isUK
          ? `/uk/thank-you?moid=${formResponseId}&flag=free`
          : `/thank-you?moid=${formResponseId}&flag=free`;

        // Check Project Already Available
        // const hasProject = await isProjectAvailable(formResponseId);
        const hasProject = true;
        console.log("has project----------------", hasProject);
        // End Frere Package

        try {
          const response = await axios.post(
            apiUrl,
            {
              mobileNumber: userData.mobile,
              name: name,
              isd: isd,
              btnUrl: finalUrl2,
              isOtpFilled:"YES"
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer vcju67w54b vuttf67t63byua213bk`,
              },
            }
          );

          const data = response.data;
          console.log("API Response from get updatedResponse:", data);
          setIsLoading(false);

          // Handle success
          if (data.flag) {
            // API call was successful
            localStorage.removeItem("timerLastRunDate");
            localStorage.removeItem("timerLastRunTime");
            localStorage.removeItem("RemainingTimerTime");
            localStorage.removeItem("offerCookie");
            localStorage.removeItem("isRedirected");
            setStep(step + 1);
            // if (hasProject) {
            //   setStep(step + 1);
            //   console.log("Document updated successfully");
            // } else {
            //   // createOrder(token,dataForFreeProduct);
            //   navigate(finalUrl);
            // }
          } else {
            setStep(step + 1);
            // if (hasProject) {
            //   setStep(step + 1);
            //   console.log("Document updated successfully");
            // } else {
            //   // createOrder(token,dataForFreeProduct);
            //   navigate(finalUrl);
            // }
            // API call failed
            console.log("Error updating document:", data.message);
          }
        } catch (error) {
          setStep(step + 1);
          // if (hasProject) {
          //   setStep(step + 1);
          //   console.log("Document updated successfully");
          // } else {
          //   // createOrder(token,dataForFreeProduct);
          //   navigate(finalUrl);
          // }
          console.log("Error for fetching response API: ", error);
          // Handle network errors or exceptions
        }
      } else if (response2.status === 404) {
        setIsLoading(false);
        alert("Error: wrong otp entered");
        return;
      } else {
        setIsLoading(false);
        throw new Error("Network response was not ok");
      }
    } catch (error) {
      setIsLoading(false);
      if (error.response) {
        // Server responded with a status code out of the range of 2xx
        if (error.response.status === 404) {
          alert(
            error.response.data.msg ||
              "Something went wrong please try again later!"
          );
        } else {
          alert(`HTTP error! Status: ${error.response.status}`);
        }
      } else if (error.request) {
        // Request was made but no response received
        alert("No response received from the server.");
      } else {
        // Something else happened while setting up the request
        alert("Error: " + error.message);
      }
    }
  };

  useEffect(() => {
    const previousPath = localStorage?.getItem("isBackCheckoutUrl");

    const modifiedUrl = previousPath;
    console.log("is coming back!");
    const timer = setTimeout(() => {
      if (
        modifiedUrl &&
        modifiedUrl?.includes(
          "/response/checkout/form_one_64e59ece81a786fc0e09fa8a"
        )
      ) {
        // window.history.pushState(window.location.href,'login url')
        const currentDate = new Date().toLocaleDateString();
        const lastRunDate = localStorage.getItem("timerLastRunDate") || "";
        const currentTime = new Date().getTime();
        const lastRunTime =
          parseInt(localStorage.getItem("timerLastRunTime")) || 0;
        const TEN_MINUTES = 10 * 60 * 1000; // 10 minutes in milliseconds
        const RemainingTime = localStorage.getItem("RemainingTimerTime");

        if (
          localStorage.getItem("isRedirected") == 1 &&
          currentDate >= lastRunDate
        ) {
          if (RemainingTime > 0 || currentDate === lastRunDate) {
            localStorage.setItem("isRedirected", 1);
            // let offcookie =
            //   localStorage.getItem("offerCookie") == "1" ? "0" : "1";
            // localStorage.setItem("offerCookie", offcookie);
            navigate(modifiedUrl);
          } else {
            localStorage.setItem("isRedirected", 0);
            localStorage.setItem("offerCookie", "1");
          }
          console.log(
            "isRedirected.....2",
            localStorage.getItem("isRedirected")
          );
        } else {
          console.log(
            "isRedirected.....3",
            localStorage.getItem("isRedirected")
          );

          localStorage.setItem("isRedirected", 1);
          navigate(modifiedUrl);
        }
      } else {
        const currentDate = new Date().toLocaleDateString();
        const lastRunDate = localStorage.getItem("timerLastRunDate") || "";
        localStorage.setItem("isRedirected", 0);
        console.log("isRedirected.....4", localStorage.getItem("isRedirected"));

        if (
          localStorage.getItem("isRedirected") == 1 &&
          currentDate > lastRunDate
        ) {
          localStorage.setItem("isRedirected", 0);
          console.log(
            "isRedirected.....5",
            localStorage.getItem("isRedirected")
          );
        }
      }
    }, 50);
    return () => clearTimeout(timer);
  }, [navigate, window.location.href]);

useEffect(() => {
  // Old 
  // if (step === 7) {
  //   const isUS = window.location.href.includes("/us");
  //   const isUK = window.location.href.includes("/uk");

  //   const finalUrl = isUS
  //     ? `/us/response/checkout/${slug}${urlQuery}&isd=${isd}&mobile=${userData?.mobile}`
  //     : isUK
  //     ? `/uk/response/checkout/${slug}${urlQuery}&isd=${isd}&mobile=${userData?.mobile}`
  //     : `/response/checkout/${slug}${urlQuery}&isd=${isd}&mobile=${userData?.mobile}`;

  //   console.log("finalUrl: ", finalUrl);
  //   navigate(finalUrl);
  // }
    if (step === 7) {

    const countryRoutes = ["us", "uk", "th", "sg","ph"];

    // current matched country
    const matchedCountry = countryRoutes.find((country) =>
      window.location.href.includes(`/${country}`)
    );

    // country prefix
    const countryPrefix = matchedCountry ? `/${matchedCountry}` : "";

    const finalUrl = `${countryPrefix}/response/checkout/${slug}${urlQuery}&isd=${isd}&mobile=${userData?.mobile}`;

    console.log("finalUrl: ", finalUrl);

    navigate(finalUrl);
  }

}, [step, slug, urlQuery, isd, userData?.mobile, navigate]);

  useEffect(() => {
    const fetchResponseData = async () => {
      const formId = urlParams.get("Fx");
      const responseId = urlParams.get("Rx");
      if (responseId) {
        setFormResponseId(responseId);
        try {
          const response = await fetch(
            `${process.env.REACT_APP_API_URL}response?q=${responseId}`
          );
          if (!response.ok) {
            throw new Error("Network response was not ok.");
          }
          const data = await response.json();
          console.log("Formatted answer data:", data.data);
          console.log("UTM Details:", data.utmDetails);

          setFormattedData(data.data);
          setUtmDetails(data.utmDetails);
        } catch (error) {
          console.error("Fetch error:", error);
        }
      }
    };

    fetchResponseData();
  }, []);

  return (
    <div className="step-form-container">
      <style>
        {`
          footer {
              display: block !important;
          }
        `}
      </style>
      <div className="step-form">
        {step === 0 && <Loader handleNext2={handleNext2} />}
        {step === 1 && (
          <StepOne
            handleCountryCodeChange={handleCountryCodeChange}
            userData={userData}
            setUserData={setUserData}
            matchedCountryCode = {matchedCountryCode}
            handleNext={handleNext}
            isLoading={isLoading}
          />
        )}
        {step === 2 && (
          <StepTwo
            otp={otp}
            setOtp={setOtp}
            handleVerifyOtp={handleVerifyOtp}
            handleNext={handleNext}
            isLoading={isLoading}
          />
        )}
        {step >= 3 && step <= 6 && (
          <PreviewStep
            step={step}
            next={() => setStep(prev => prev + 1)}
            slug={slug}
            isd={isd}
            mobile={userData.mobile}
            urlQuery={urlQuery}
          />
        )}

        {/* {step === 3 && <StepThree slug={slug} isd={isd} mobile={userData.mobile} responseId={formResponseId} />} */}
      </div>
    </div>
  );
};

export default StepForm;
